
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormat',
    standalone: true
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Split the date string into day, month, and year
    const [day, month, year] = value.split('-');

    // Create a new date string in the desired format
    const transformedDate = `${day}/${month}/${year}`;

    return transformedDate;
  }

}